import { Platform } from 'react-native';
import { useFonts as useFontsBase, type FontSource } from 'expo-font';
import { InstrumentSerif_400Regular, InstrumentSerif_400Regular_Italic } from '@expo-google-fonts/instrument-serif';
import {
  Geist_400Regular,
  Geist_500Medium,
  Geist_600SemiBold,
} from '@expo-google-fonts/geist';
import {
  JetBrainsMono_400Regular,
  JetBrainsMono_500Medium,
} from '@expo-google-fonts/jetbrains-mono';

// On web the fonts are self-hosted woff2 declared via @font-face in
// src/app/+html.tsx (with font-display: swap), so nothing is loaded here and
// rendering never blocks on fonts. Native still loads the TTFs via expo-font.
const NATIVE_FONTS: Record<string, FontSource> =
  Platform.OS === 'web'
    ? {}
    : {
        InstrumentSerif_400Regular,
        InstrumentSerif_400Regular_Italic,
        Geist_400Regular,
        Geist_500Medium,
        Geist_600SemiBold,
        JetBrainsMono_400Regular,
        JetBrainsMono_500Medium,
      };

export function useAppFonts(): [boolean, Error | null] {
  const [loaded, error] = useFontsBase(NATIVE_FONTS);
  if (Platform.OS === 'web') return [true, null];
  return [loaded, error];
}
